<template>
     <USelectMenu
    v-model="selectedClientId"
    :items="clientsAvailable"
    placeholder="Select a client"
    :search-input="{ placeholder: 'Search by name' }"
    label-key="name"
    value-key="id"
    :search-attributes="['name']"
    :loading="status == 'pending'"
  />
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/user';

const userStore = useUserStore()
const { setSelectedClient, accessLevel } = userStore
const { accessLevel: accessLevelComputed, selectedClient: selectedClientFromStore } = storeToRefs(userStore)

if(!selectedClientFromStore.value?.id){
    setSelectedClient(accessLevelComputed.value![0]!.client_id)
}

const clientsAvailable = computed(() => {
    if (!accessLevelComputed.value) return []
    
    return accessLevelComputed.value?.map(client => ({
        id: client.client_id,
        name: client.name
    }))
})

const selectedClientId = computed({
    get: () => selectedClientFromStore.value?.id,
    set: (value) => {
        if (value) {
            setSelectedClient(value)
        }
    }
})

const status = ref('idle')

if(accessLevel?.length === 0){
    throw createError({
        statusCode: 403,
        statusMessage: 'No clients available'
    })
};

if(accessLevel?.length === 1){
    setSelectedClient(accessLevel[0]!.client_id)
}
</script>
